module.exports = __webpack_public_path__ + "static/img/advantage.0c34c4d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/repair/advantage.png
// module id = /WZz
// module chunks = 4